import { getGroupEditLink } from '~/utils/getLinks';
import { useGroupDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { GroupDetailPresentation } from './presentations';

type Props = {
  id: number;
};

/**
 * グループ詳細のコンテナコンポーネント
 */
export const GroupDetail: React.FC<Props> = ({ id }) => {
  const {
    state: { data },
  } = useGroupDetail(id);

  const { groupDetail } = convertToPresentationProps({ data });

  return (
    <GroupDetailPresentation groupDetail={groupDetail} editLink={getGroupEditLink(String(id))} />
  );
};
